import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=21ccd90c&scoped=true&"
import script from "./payment.vue?vue&type=script&lang=js&"
export * from "./payment.vue?vue&type=script&lang=js&"
import style0 from "./payment.vue?vue&type=style&index=0&id=21ccd90c&prod&lang=scss&scoped=true&"
import style1 from "./payment.vue?vue&type=style&index=1&id=21ccd90c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ccd90c",
  null
  
)

export default component.exports